import type { ReactNode } from "react";
import Button from "../Button/Button";
import Icon from "../Icon/Icon";
import "./PageHeader.css";

export interface PageHeaderProps {
  title: ReactNode;
  /** grey text under the title */
  description?: ReactNode;
  /** buttons on the right */
  actions?: ReactNode;
  /** shows a back arrow before the title (detail pages) */
  onBack?: () => void;
  /** label for the back arrow, for screen readers */
  backLabel?: string;
  className?: string;
}

/**
 * Title row at the top of an app page (Tenants, Properties, ...).
 * Example: <PageHeader title="Tenants" actions={<Button>Invite</Button>} />
 */
const PageHeader = ({
  title,
  description,
  actions,
  onBack,
  backLabel = "Back",
  className = "",
}: PageHeaderProps) => (
  <header className={`ds-page-header ${className}`.trim()}>
    <div className="ds-page-header__text">
      <div className="ds-page-header__title-row">
        {onBack && (
          <Button
            variant="ghost"
            iconOnly
            aria-label={backLabel}
            iconStart={<Icon name="chevronLeft" />}
            onClick={onBack}
          />
        )}
        <h1 className="ds-page-header__title">{title}</h1>
      </div>
      {description && (
        <p className="ds-page-header__description">{description}</p>
      )}
    </div>
    {actions && <div className="ds-page-header__actions">{actions}</div>}
  </header>
);

export default PageHeader;
